Vue.component('packOpeningRequestButton', {
  template: templates.packOpeningRequestButton,
  data() {
    return {
      showRequestModal: false,
      selectedPackId: '',
      isLoading: false,
      submitting: false,
      showSuccessState: false,
      statusMessage: null,
      availablePacks: [],
      userRequests: {
        pending: [],
        approved: [],
        declined: [],
        completed: []
      },
      cooldownInfo: {
        isOnCooldown: false,
        timeRemaining: 0
      },
      requestStatus: 'pending',
      channelId: null,
      userCurrentPacks: {},
      cooldownCheckInterval: null
    };
  },
  computed: {
    canShowButton() {
      // Show button if user has "Show Only Mine" or "Hide All" visibility
      const userVisibility = localStorage.getItem('obsViewerPreference') || 'all';
      return userVisibility !== 'all';
    }
  },
  mounted() {
    const c = this;

    // Get channel ID from the page/component context
    // This should be the streamer's channel ID
    c.channelId = utils.cookies.get('channel_id') || window.streamerChannelId;

    // Load available packs for user
    c.loadAvailablePacks();

    // Load user's existing requests
    c.loadUserRequests();

    // Check cooldown status
    c.checkCooldown();

    // Set up cooldown timer
    c.cooldownCheckInterval = setInterval(() => {
      c.checkCooldown();
    }, 1000);
  },
  beforeDestroy() {
    if (this.cooldownCheckInterval) {
      clearInterval(this.cooldownCheckInterval);
    }
  },
  methods: {
    openRequestModal() {
      this.showRequestModal = true;
      this.selectedPackId = '';
      this.statusMessage = null;
      this.showSuccessState = false;
    },

    closeRequestModal() {
      this.showRequestModal = false;
      this.selectedPackId = '';
      this.statusMessage = null;
      this.showSuccessState = false;
      this.submitting = false;
    },

    loadAvailablePacks() {
      const c = this;
      c.isLoading = true;

      // Load packs from packService
      if (window.packService && window.packService.get) {
        packService.get()
          .then(response => {
            c.userCurrentPacks = response.data || {};

            // Format packs for display
            c.availablePacks = Object.values(c.userCurrentPacks).map(pack => ({
              id: pack.id,
              type: pack.type || 'standard',
              displayName: `${pack.type || 'Standard'} Pack`,
              packType: pack.type
            }));

            c.isLoading = false;
          })
          .catch(error => {
            console.error('Error loading packs:', error);
            c.isLoading = false;
            c.statusMessage = {
              type: 'alert-danger',
              text: 'Failed to load available packs'
            };
          });
      } else {
        c.isLoading = false;
        c.statusMessage = {
          type: 'alert-danger',
          text: 'Pack service not available'
        };
      }
    },

    loadUserRequests() {
      const c = this;

      if (!window.packRequestService) {
        console.warn('packRequestService not available');
        return;
      }

      packRequestService.getMyRequests({ channelId: c.channelId })
        .then(response => {
          const requests = response.data || [];

          // Organize requests by status
          c.userRequests = {
            pending: requests.filter(r => r.status === 'pending'),
            approved: requests.filter(r => r.status === 'approved'),
            declined: requests.filter(r => r.status === 'declined'),
            completed: requests.filter(r => r.status === 'completed')
          };
        })
        .catch(error => {
          console.error('Error loading user requests:', error);
        });
    },

    checkCooldown() {
      const c = this;
      const lastRequestTime = localStorage.getItem('lastPackRequestTime');
      const COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24 hours

      if (!lastRequestTime) {
        c.cooldownInfo = {
          isOnCooldown: false,
          timeRemaining: 0
        };
        return;
      }

      const lastTime = parseInt(lastRequestTime);
      const now = Date.now();
      const timePassed = now - lastTime;

      if (timePassed < COOLDOWN_MS) {
        const timeRemaining = COOLDOWN_MS - timePassed;
        c.cooldownInfo = {
          isOnCooldown: true,
          timeRemaining: timeRemaining
        };
      } else {
        c.cooldownInfo = {
          isOnCooldown: false,
          timeRemaining: 0
        };
      }
    },

    formatTimeRemaining(ms) {
      const totalSeconds = Math.floor(ms / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
      }
      return `${seconds}s`;
    },

    submitRequest() {
      const c = this;

      if (!c.selectedPackId) {
        c.statusMessage = {
          type: 'alert-danger',
          text: 'Please select a pack'
        };
        return;
      }

      if (c.cooldownInfo.isOnCooldown) {
        c.statusMessage = {
          type: 'alert-danger',
          text: 'You must wait before submitting another request'
        };
        return;
      }

      c.submitting = true;
      c.statusMessage = null;

      const pack = c.userCurrentPacks[c.selectedPackId];

      packRequestService.submitPackRequest({
        channelId: c.channelId,
        packId: c.selectedPackId,
        packType: pack?.type || 'standard'
      })
        .then(response => {
          if (response.data.success) {
            // Set cooldown
            localStorage.setItem('lastPackRequestTime', Date.now().toString());

            // Show success state
            c.showSuccessState = true;
            c.requestStatus = 'pending';
            c.submitting = false;

            // Reload user requests
            c.loadUserRequests();

            // Close modal after 2 seconds
            setTimeout(() => {
              c.closeRequestModal();
            }, 2000);
          } else {
            c.submitting = false;
            c.statusMessage = {
              type: 'alert-danger',
              text: response.data.message || 'Failed to submit request'
            };
          }
        })
        .catch(error => {
          c.submitting = false;
          console.error('Error submitting request:', error);
          c.statusMessage = {
            type: 'alert-danger',
            text: error.response?.data?.message || 'Error submitting request'
          };
        });
    }
  }
});
